import {UserPermissions} from '../../../../common/elf-store/user-permissions/user-permissions.store';
import {UserPermissionsType} from '../../../../common/elf-store/user-permissions/user-permissions.type';
import {
  BaseEvent,
  ClickAccessibilityMonitorNavbar,
  ClickAccessibilityServicesNavbar,
  ClickAgencyResourcesNavbar,
  ClickAuditsNavbar,
  ClickContactSupportNavbar,
  ClickDevResourcesNavbar,
  ClickDocumentsPdfsNavbar,
  ClickEmbedCodeNavbar,
  ClickFixMyCodeNavbar,
  ClickImageAltsNavbar,
  ClickLegalSupportProgramNavbar,
  ClickManagedAccessibilityNavbar,
  ClickMySitesNavbar,
  ClickRegulationTrackerNavbar,
  ClickServerApiResourceNavbar,
  ClickSupportDocumentationNavbar,
  ClickSupportServicesNavbar,
  ClickVideoRemediationsNavbar,
  ClickVpatNavbar,
} from '../../../../services/ampli';

export interface MenuItem {
  label: string;
  icon?: string;
  menuItems?: MenuItem[];
  routerLink: string;
  isOpened?: boolean;
  onClick?: () => void;
  intro?: string;
  gtmEvent: string;
  iconActive?: string;
  labelIcon?: string;
  labelIconActive?: string;
  permission?: UserPermissionsType;
  amplitudeEventInstance?: BaseEvent;
}

export const SIDE_NAV_MENU: MenuItem[] = [
  {
    label: 'MENU.EMBED-CODE',
    icon: 'embed_code',
    routerLink: '/embed-code',
    gtmEvent: 'nav-embed-code',
    amplitudeEventInstance: new ClickEmbedCodeNavbar(),
    permission: UserPermissions.manageEmbedCode.manageEmbedCodeTab as UserPermissionsType,
  },
  {
    label: 'MENU.ACCESSIBILITY-WIDGET',
    icon: 'man',
    routerLink: '/widget',
    gtmEvent: 'nav-my-sites',
    amplitudeEventInstance: new ClickMySitesNavbar(),
  },
  {
    label: 'MENU.MY-SCANS',
    icon: 'scanner',
    iconActive: 'scanner_white',
    routerLink: '/scanner',
    isOpened: false,
    gtmEvent: 'nav-my-scans',
    permission: UserPermissions.manageScans.scansTab as UserPermissionsType,
    amplitudeEventInstance: new ClickAccessibilityMonitorNavbar(),
  },
  {
    label: 'MENU.IMAGE-ALTS',
    icon: 'image_alts',
    routerLink: '/image-alts',
    intro: 'imgAlts',
    gtmEvent: 'nav-image-alts',
    permission: UserPermissions.manageImageAlts.imageAltsTab as UserPermissionsType,
    amplitudeEventInstance: new ClickImageAltsNavbar(),
  },
  {
    label: 'MENU.DOCUMENTS-PDF',
    icon: 'documents',
    routerLink: '/documents-and-pdfs',
    gtmEvent: 'nav-documents-pdfs',
    permission: UserPermissions.managePdfs.pdfsTab as UserPermissionsType,
    amplitudeEventInstance: new ClickDocumentsPdfsNavbar(),
  },
  {
    label: 'MENU.ACCESSIBILITY-SERVICES',
    icon: 'accessibility',
    routerLink: '/audits',
    isOpened: false,
    gtmEvent: 'nav-accessibility-services',
    permission: UserPermissions.manageAccessibilityServices.manageAccessibilityServicesTab as UserPermissionsType,
    amplitudeEventInstance: new ClickAccessibilityServicesNavbar(),
    menuItems: [
      {
        label: 'MENU.AUDITS',
        routerLink: '/audits',
        gtmEvent: 'nav-audits',
        permission: UserPermissions.manageAccessibilityServices.manageAccessibilityAudit as UserPermissionsType,
        amplitudeEventInstance: new ClickAuditsNavbar(),
      },
      {
        label: 'MENU.VPAT',
        routerLink: '/vpat',
        gtmEvent: 'nav-vpat',
        permission: UserPermissions.manageAccessibilityServices.manageAccessibilityVPAT as UserPermissionsType,
        amplitudeEventInstance: new ClickVpatNavbar(),
      },
      {
        label: 'SERVICES.COMPLIANCE',
        routerLink: '/compliance',
        gtmEvent: 'nav-managed',
        permission: UserPermissions.manageAccessibilityServices.manageAccessibilityVPAT as UserPermissionsType,
        amplitudeEventInstance: new ClickManagedAccessibilityNavbar(),
      },
      {
        label: 'MENU.LEGAL-SERVICES',
        routerLink: '/legal',
        gtmEvent: 'nav-legal',
        permission: UserPermissions.manageAccessibilityServices.manageAccessibilityLegalSupport as UserPermissionsType,
        amplitudeEventInstance: new ClickLegalSupportProgramNavbar(),
      },
      {
        label: 'MENU.VIDEO-REMEDIATIONS',
        routerLink: '/video',
        gtmEvent: 'nav-video',
        permission: UserPermissions.manageAccessibilityServices
          .manageAccessibilityLegalVideosRemediations as UserPermissionsType,
        amplitudeEventInstance: new ClickVideoRemediationsNavbar(),
      },
    ],
  },
  {
    label: 'MENU.DEV-RESOURCES',
    icon: 'dev-resources',
    iconActive: 'dev-resources_white',
    isOpened: false,
    routerLink: '/server-api',
    gtmEvent: 'dev-resources',
    permission: UserPermissions.manageDeveloperResources.manageDeveloperResourcesTab as UserPermissionsType,
    amplitudeEventInstance: new ClickDevResourcesNavbar(),
    menuItems: [
      {
        label: 'DEV-RESOURCES.SERVER-SIDE-API',
        routerLink: '/server-api',
        gtmEvent: 'nav-server-api',
        permission: UserPermissions.manageDeveloperResources
          .manageDeveloperResourcesServerSideApi as UserPermissionsType,
        amplitudeEventInstance: new ClickServerApiResourceNavbar(),
      },
    ],
  },
];

export const AGENCY_MENU_ITEM = {
  label: 'MENU.AGENCY',
  icon: 'agency',
  routerLink: '/agency',
  gtmEvent: 'nav-agency-portal',
  permission: UserPermissions.manageAgencyResources.manageAgencyResourcesTab as UserPermissionsType,
  amplitudeEventInstance: new ClickAgencyResourcesNavbar(),
};

export const REGULATION_MENU_ITEM = {
  label: 'MENU.REGULATION',
  icon: 'regulation',
  iconActive: 'regulation-white',
  routerLink: '/regulation',
  gtmEvent: 'nav-regulation-tracker',
  labelIcon: 'beta_label',
  labelIconActive: 'beta_label_white',
  permission: UserPermissions.manageRegTracker.manageRegTrackerTab as UserPermissionsType,
  amplitudeEventInstance: new ClickRegulationTrackerNavbar(),
};

export const FIX_MY_CODE_SUB_MENU_ITEM = {
  label: 'DEV-RESOURCES.FIX-MY-CODE',
  routerLink: '/fix-my-code',
  gtmEvent: 'nav-fix-my-code',
  amplitudeEventInstance: new ClickFixMyCodeNavbar(),
};

export const SUPPORT_SERVICES = {
  label: 'MENU.SUPPORT-SERVICES',
  icon: 'resources',
  iconActive: 'resources_white',
  isOpened: false,
  gtmEvent: 'support-service',
  routerLink: '/onboarding-resources',
  permission: UserPermissions.manageSupportServices.manageSupportServicesTab as UserPermissionsType,
  amplitudeEventInstance: new ClickSupportServicesNavbar(),
  menuItems: [
    {
      label: 'SUPPORT-SERVICES.ONBOARDING-RESOURCES',
      gtmEvent: 'nav-onboarding-resources',
      routerLink: '/onboarding-resources',
    },
    {
      label: 'SUPPORT-SERVICES.DOCUMENTATION',
      gtmEvent: 'nav-documentation',
      routerLink: '/documentation',
      amplitudeEventInstance: new ClickSupportDocumentationNavbar(),
    },
    {
      label: 'SUPPORT-SERVICES.EMAIL-SUPPORT',
      gtmEvent: 'nav-email-support',
      routerLink: '/email-support',
      amplitudeEventInstance: new ClickContactSupportNavbar(),
    },
    {
      label: 'SUPPORT-SERVICES.FAQ',
      gtmEvent: 'nav-faq',
      routerLink: '/faq',
    },
  ],
};
